import styled, { useTheme } from "styled-components";
import { FlexColumn } from "Routes/styled";
import { Button } from "melodies-source/Button";
import { Body1, Body2, H2, H4 } from "melodies-source/Text";
import { SvgBuilderLarge } from "melodies-source/Svgs/BuilderLarge";
import { useTemplates } from "./TemplateContext";
import { surveyTemplates } from "./defaults";
import { SelectionCard, IconContainer } from "Components/SelectionCard";
import {
  ResponsiveModal,
  ResponsiveFooterActions,
} from "Components/ResponsiveModal";

interface SelectTemplateProps {
  onBack: VoidFunction;
}

export const SelectTemplateModal = ({ onBack }: SelectTemplateProps) => {
  const {
    isLoading,
    templateCategory,
    setSelectedTemplate,
    selectedTemplate,
    setModal,
    modal,
  } = useTemplates();
  const templateByCategory = surveyTemplates[templateCategory];
  const { colors } = useTheme();
  const templates = Object.values(templateByCategory?.templates || {});

  return (
    <ResponsiveModal
      header={
        <>
          <H2>Select a Template</H2>
          <Body1>{templateByCategory?.modalHeader}</Body1>
        </>
      }
      isOpen={modal.selectTemplate}
      variant="large"
    >
      {!templates?.length ? (
        <NoTemplates style={{ color: "#666666" }}>
          <SvgBuilderLarge />
          <Body1>
            There are currently no templates available for this category.
          </Body1>
        </NoTemplates>
      ) : (
        <CardContainer>
          {templates.map((tmpl) => (
            <StyledSelectionCard
              icon={tmpl.icon}
              header={tmpl.title}
              subHeader={tmpl.description}
              onClick={() => {
                if (!isLoading) {
                  setSelectedTemplate(tmpl);
                }
              }}
              selected={tmpl.templateId === selectedTemplate?.templateId}
              key={`template-${tmpl.templateId}`}
            />
          ))}
        </CardContainer>
      )}
      <ResponsiveFooterActions>
        <Button
          variant="tertiary"
          onClick={() => onBack()}
          style={{ color: colors.main }}
          disabled={isLoading}
        >
          Back
        </Button>
        <Button
          variant="primary"
          loading={isLoading}
          onClick={() => setModal({ selectTemplate: false, aiPrompt: true })}
          disabled={selectedTemplate === undefined}
        >
          Next
        </Button>
      </ResponsiveFooterActions>
    </ResponsiveModal>
  );
};

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 12px;
  column-gap: 20px;

  ${({ theme }) => theme.mediaQueries.desktop} {
    row-gap: 16px;
    grid-template-columns: 1fr 1fr;
  }
`;

const NoTemplates = styled(FlexColumn)`
  color: #666;
  align-items: center;
  padding: 52px 53px 60px 53px;
  max-width: 372px;
  margin: 80px auto 80px auto;

  svg {
    width: 118px;
    height: 118px;
    color: #e8e5f1;
    margin-bottom: 16px;
  }

  ${Body1} {
    color: #333333;
    text-align: center;
  }
`;

const StyledSelectionCard = styled(SelectionCard)`
  ${H4} {
    margin-top: 3px;
  }
  ${Body2} {
    margin-top: 2px;
  }
  ${IconContainer} {
    align-self: flex-start;
    width: 32px;
    margin-right: 12px;
    & > svg {
      width: 32px;
      height: 32px;
    }
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    padding: 12px 20px 12px 16px;
  }
`;
